module.exports = __webpack_public_path__ + "static/media/seguradora_gboex.05867e65.jpg";